module.exports = __webpack_public_path__ + "img/locationEmptyIcon.3b9c76fc.svg";